module.exports = __webpack_public_path__ + "static/media/eye.adf204ad.svg";